<template>
  <path
    d="M18.75 3.94018L4.06999 10.0802C3.23999 10.4302 3.25999 11.6102 4.08999 11.9302L9.42999 14.0002C9.68999 14.1002 9.89999 14.3102 9.99999 14.5702L12.06 19.9002C12.38 20.7402 13.57 20.7602 13.92 19.9302L20.07 5.26018C20.4 4.43018 19.57 3.60018 18.75 3.94018Z"
  />
</template>
